import Vue from 'vue'
import Vuex from 'vuex'
import { SupportAudioType, SupportVideoType, RoleMapping } from '@/utils/format'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fileType: '',
    fileInfo: null, // 文件信息
    userInfo: null, // 用户信息
    userSelf: {}, // 企业用户信息，个人账号默认为空对象，避免报错
    playing: false, // 媒体是否播放中
    audioLoading: false, // 音频加载中
    duration: 0, // 媒体总时长
    currentTime: 0, // 当前播放时长
    muted: false, // 是否静音
    volume: 0.5, // 音量大小
    showMobileMenu: false, // 是否显示移动端菜单
    filestar: false, // 是否标星
    filePath: [], // 文件路径
    documentTitleChange: true
  },
  mutations: {
    SET_FILE_TYPE(state, payload = '') {
      const ext = (payload.split('.').reverse()[0]).toLowerCase()
      let fileType = 'unknown'
      if (SupportVideoType.includes(ext)) {
        fileType = 'video'
      } else if (SupportAudioType.includes(ext)) {
        fileType = 'audio'
      }
      state.fileType = fileType

      // 根据文件类型设置favicon
      this.commit('SET_FAVICON', fileType)
    },
    SET_FAVICON(state, payload) {
      let linkTag = document.createElement('link')
      linkTag.rel = 'shortcut icon'
      let favicon = ''
      switch (payload) {
        case 'video':
          favicon = 'favicon_video.png'
          break
        case 'audio':
          favicon = 'favicon_audio.png'
          break
        case 'unknown':
          favicon = 'favicon_unknown.png'
          break
        default:
          favicon = 'favicon_docs.png'
      }
      linkTag.href = process.env.VUE_APP_STATIC_URL + process.env.VUE_APP_CDN_PATH + 'img/' + favicon
      document.head.appendChild(linkTag)
    },
    SET_FILE_INFO(state, payload) {
      state.fileInfo = payload

      // 根据文件名设置title
      if (payload.fname && state.documentTitleChange) {
        document.title = payload.fname.replace(/\.\w+$/, '')
      }
    },
    SET_DOCUMENT_TITLE(state, payload) {
      state.documentTitleChange = payload
    },
    SET_USER_INFO(state, payload) {
      state.userInfo = payload
    },
    SET_USER_SELF(state, payload) {
      state.userSelf = { ...payload, roles: RoleMapping[payload.role_id] }
    },
    SET_PLAY_STATUS(state, payload) {
      state.playing = payload
    },
    SET_AUDIO_LOADING(state, payload) {
      state.audioLoading = payload
    },
    SET_MEDIA_DURATION(state, payload) {
      state.duration = payload
    },
    SET_MEDIA_CURRENT_TIME(state, payload) {
      if (payload >= state.duration) {
        payload = state.duration
      }
      state.currentTime = payload
    },
    SET_MUTE_STATUS(state, payload) {
      state.muted = payload
    },
    SET_VOLUME(state, payload) {
      state.volume = payload
    },
    SET_MOBILE_MENU(state, payload) {
      state.showMobileMenu = payload
    },
    SET_FILE_STAR(state, payload) {
      state.filestar = payload
    },
    SET_FILE_PATH(state, payload) {
      let paths = [payload.corp_name, payload.group_name]
      let { path } = payload
      if (path.length) {
        path.map(item => paths.push(item.folder_name))
      }
      state.filePath = paths
    }
  },
  actions: {

  },
  getters: {
    isCompanyAuth(state) {
      if (state.userSelf.comp_auth && state.userSelf.comp_auth.auth_status === 'certified') {
        return true
      }
      return false
    }
  }
})
